module.exports = __webpack_public_path__ + "img/home_bg_2.3da28e71.png";